export * from './replace-broken-image.component';
